// extracted by mini-css-extract-plugin
export default {"main":"Address_main__wcRkn","addressform":"Address_addressform__tb7I0"};